import {
  Breadcrumbs,
  Card,
  CardContent,
  Divider,
  Grid,
  Link,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

import { NavLink, useNavigate, useParams } from "react-router-dom";

import MediaSectionAddUpdateForm from "../../components/Media/MediaSectionAddUpdateForm";

// import VideoAddUpdateForm from "../../components/media/mediaAddUpdateForm";

import { toast } from "react-toastify";
import swal from "sweetalert";
import { uploadDbFile } from "../../api/dbFile";
import {
  createMedia,
  getAllCategoriesNoPg,
  getMediaInfo,
  updateMedia
} from "../../api/media";
import MediaAddUpdateForm from "../../components/Media/MediaAddUpdateForm";

export default function AddUpdatePodcast({ navigate_to }) {
  const navigate = useNavigate();
  const urlParams = useParams();
  const mediaId = urlParams?.id;

  const [showAddUpdateSection, setShowAddUpdateSection] = useState(false);
  const [mediaIdForSection, setMediaIdForSection] = useState(mediaId);

  const [mediaDetails, setMediaDetails] = useState({});
  const [allSectionRequest, setAllSectionRequest] = useState([]);

  const [sectionRequest, setSectionRequest] = useState({});
  const [activeMediaSectionId, setActiveMediaSectionId] = useState(null);

  // Categories
  const [categories, setCategories] = useState([]);

  //
  const [isLoading, setIsLoading] = useState(false);

  const toggleAddUpdateSection = () => {
    setShowAddUpdateSection((prev) => !prev);
  };

  const fetchVideosInfoById = () => {
    if (mediaId) {
      setIsLoading(true);
      getMediaInfo(mediaId)
        .then((res) => {
          if (res.data.success) {
            setMediaDetails(res.data.payload.pageContent);
            setAllSectionRequest(res.data.payload.pageSections);
            setIsLoading(false);
          }
        })
        .catch((err) => toast.error(err.response.data.message));
    } else {
    }
  };

  const handleSubmitVideo = async (values) => {
    //  Duration minute and second validation...
    if (
      parseInt(values?.duration[3]) > 5 ||
      parseInt(values?.duration[6]) > 5
    ) {
      toast.error(
        "Minutes/Seconds values are exceeding the limit in the duration field"
      );
      return false;
    }

    setIsLoading(true);
    if (values.image && !values.image.fileUrl) {
      const formData = new FormData();
      formData.append("file", values.image);
      formData.append("fileType ", values.image.type);
      formData.append("fileUploadType", "VIDEO_PODCAST");

      uploadDbFile(formData).then((res) => {
        if (res.data.success) {
          const data = {
            title: values?.title,
            active: values?.active,
            slider: false,
            mediaLink: values?.mediaLink,
            mediaCategoryId: values?.mediaCategoryId,
            shortDescription: values?.shortDescription,
            sectionRequests: allSectionRequest,
            id: mediaId,
            video: false,
            mediaPreviewId: res.data.payload.id,
            duration: values?.duration,
            privateMedia: values.privateMedia ?? false,
            speaker: values?.speaker
          };
          if (mediaId) {
            updateMedia(data)
              .then((res) => {
                if (res.data.success) {
                  toast.success(res.data.message);
                  setIsLoading(false);
                  return navigate(`/${navigate_to}`);
                }
              })
              .catch((err) => toast.error(err.response.data.message));
          } else {
            createMedia(data)
              .then((res) => {
                if (res.data.success) {
                  toast.success(res.data.message);
                  setIsLoading(false);
                  return navigate(`/${navigate_to}`);
                }
              })
              .catch((err) => toast.error(err.response.data.message));
          }
        }
      });
    } else {
      const data = {
        ...values,
        sectionRequests: allSectionRequest,
        id: mediaId,
        slider: false,
        mediaPreviewId: values?.image?.fileUrl ? values?.image?.id : 0,
        video: false,
        speaker: values?.speaker
      };
      if (mediaId) {
        updateMedia(data)
          .then((res) => {
            if (res.data.success) {
              toast.success(res.data.message);
              setIsLoading(false);
              return navigate(`/${navigate_to}`);
            }
          })
          .catch((err) => toast.error(err.response.data.message));
      } else {
        createMedia(data)
          .then((res) => {
            if (res.data.success) {
              toast.success(res.data.message);
              setIsLoading(false);
              return navigate(`/${navigate_to}`);
            }
          })
          .catch((err) => toast.error(err.response.data.message));
      }
    }
  };

  const handleSectionEditClick = (id) => {
    setShowAddUpdateSection((prev) => !prev);

    setActiveMediaSectionId(id);

    const sectionRequestToUpdate = allSectionRequest[id];
    setSectionRequest(sectionRequestToUpdate);
  };
  const handleSubmitSection = async (values, mediaId) => {
    // Has Image ...
    if (values.imageFileId) {
      // isCreate ???
      // ---do something....
      // isNotCreate ???
      //  ---do something....
    }
    // Has No Image ....
    else {
      const data = {
        ...values,
      };
      if (Object.keys(sectionRequest).length > 0) {
        const newArr = [...allSectionRequest];
        newArr[activeMediaSectionId] = data;

        setAllSectionRequest([...newArr]);
      }
      // create...
      else {
        const newCopy = [...allSectionRequest];
        newCopy.push({
          ...data,
        });
        console.log(newCopy);
        setAllSectionRequest(newCopy);
      }
      setSectionRequest({});
      setActiveMediaSectionId(null);
    }

    toggleAddUpdateSection();
  };
  const deleteSection = (e, arrIdx) => {
    console.log(arrIdx);
    if (arrIdx >= 0) {
      swal({
        // title: "Are you sure?",
        text: "Are you sure to delete the section ???",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            const newArr = [...allSectionRequest];
            newArr.splice(arrIdx, 1);
            setAllSectionRequest([...newArr]);
          }
          // else {
          //     swal("Your imaginary file is safe!");
          // }
        })
        .catch((err) => toast.error(err.response.data.message));
    }
  };
  const fetchCategories = () => {
    const params = {
      active: true,
      video: false,
    };
    getAllCategoriesNoPg({ params })
      .then((res) => {
        if (res.data.success) {
          setCategories(res.data.payload);
        }
      })
      .catch((err) => toast.error(err.response.data.message));
  };

  useEffect(() => {
    fetchVideosInfoById();
    fetchCategories();
  }, []);

  return (
    <>
      <Helmet title="Podcast" />
      <Grid
        justifyContent="space-between"
        alignItems={"end"}
        container
        spacing={10}
        mb={5}
      >
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            {showAddUpdateSection
              ? "Add / Update Section"
              : mediaId
                ? "Update Podcast"
                : "Add Podcast"}
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to={`/${navigate_to}`}>
              Podcasts
            </Link>
            <Typography>{mediaId ? "Update" : "Add"}</Typography>
          </Breadcrumbs>
        </Grid>

        {/* {!showAddUpdateSection && (
          <Grid item>
            <Button
              onClick={toggleAddUpdateSection}
              variant="contained"
              color="primary"
              sx={{ ml: 2 }}
            >
              <AddCircleOutlineIcon sx={{ mr: 1 }} />
              Add Section
            </Button>
          </Grid>
        )} */}
      </Grid>
      <Divider my={3} />
      {showAddUpdateSection && (
        <Grid container spacing={6} justifyContent="center" mt={5}>
          <Grid item xs={12} md={10} lg={8} xl={6} mt={5}>
            <MediaSectionAddUpdateForm
              toggleAddUpdateSection={toggleAddUpdateSection}
              // allSectionRequest={allSectionRequest}
              sectionRequest={sectionRequest}
              // handleSectionEditClick={handleSectionEditClick}
              handleSubmitSection={handleSubmitSection}
              navigateTo={`/${navigate_to}`}
              mediaId={mediaId}
            />
          </Grid>
        </Grid>
      )}

      <Grid container spacing={6} justifyContent={"center"}>
        <Grid item xs={12} md={10} lg={8} xl={6} mt={5}>
          {
            <Card
              sx={{
                display: showAddUpdateSection ? "none" : "block",
                padding: "30px",
              }}
            >
              <CardContent>
                <MediaAddUpdateForm
                  mediaDetails={mediaDetails}
                  navigateTo={`/${navigate_to}`}
                  navigate={navigate}
                  isLoading={isLoading}
                  handleSubmitVideo={handleSubmitVideo}
                  video={false}
                  audio={true}
                  allSectionRequest={allSectionRequest}
                  categories={categories}
                  handleSectionEditClick={handleSectionEditClick}
                  deleteSection={deleteSection}
                  // field to show in the form....
                  hasImg={true}
                  hasTitle={true}
                  hasDescription={false}
                  hasShortDescription={true}
                  hasConent={true}
                  hasCategory={true}
                  hasExtLink={false}
                  hasLink={true}
                  hasStatus={true}
                  hasSpeaker={true}
                  hasDuration={true}
                  hasPrivate={true}
                />
              </CardContent>
            </Card>
          }
        </Grid>
      </Grid>
    </>
  );
}
